import { put } from 'redux-saga/effects';

import * as actions from '../../actions';

// eslint-disable-next-line import/prefer-default-export
export function* showRegisterFormPage(event) {
  yield put(actions.showRegisterFormPage(event.payload));
}
